<template>
    <div>
        <div class="student-title" v-if="title">{{title}}</div>
        <div class="student-data">
            <div class="student-report">
                <div class="head-general" v-if="this.ifShow">
                    <Evaluate :seriousness="seriousness" :positive="positive" :progress="progress"
                        :level="comprehensive"
                        :VoiceUrl="teacherUrl " :time="teacherVoiceTime"></Evaluate>
                </div>
                <div class="voice-card" v-if="studentSpeechTopicDtoList.length > 0">
                    <p>语音题<span class="total-color">{{speechTotalNum}}道</span> &nbsp| &nbsp易错题<span
                        class="wrong-color">{{speechWrongNum}}道</span></p>
                    <div class="card-whole">
                        <VoiceCard v-for="(question, index) in studentSpeechTopicDtoList" :key="index"
                            :question="question"></VoiceCard>
                    </div>
                </div>
                <div class="speech-whole" v-if="teacherSpeechUrl">
                    <SpeechEvaluation :value="1" :VoiceUrl="teacherSpeechUrl "
                        :time="teacherSpeechVoiceTime "></SpeechEvaluation>
                </div>
                <div class="line" v-if="studentSpeechTopicDtoList.length > 0"></div>
                <div class="voice-card" v-if="studentGamesWrongDtoList.length > 0">
                    <p>选择题<span class="total-color">{{gameTotalNume}}道</span> &nbsp| &nbsp答错<span
                        class="wrong-color">{{gameWrongNum}}道</span></p>
                    <div class="card-whole">
                        <ChoiceCard v-for="(option,index) in studentGamesWrongDtoList" :key="index"
                            :question="option"></ChoiceCard>
                    </div>
                </div>
                <div class="voice-card" v-if="studentGamesRightDtoList.length > 0">
                    <p>选择题<span class="total-color">{{gameTotalNume}}道</span> &nbsp| &nbsp答对<span
                        class="right-color">{{gameRightNum}}道</span></p>
                    <div class="card-whole">
                        <ChoiceCard v-for="(option,index) in studentGamesRightDtoList" :key="index"
                            :question="option"></ChoiceCard>
                    </div>
                </div>
                <div class="speech-whole" v-if="teacherGamesUrl">
                    <SpeechEvaluation :value="2" :VoiceUrl="teacherGamesUrl"
                        :time="teacherGamesVoiceTime"></SpeechEvaluation>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SpeechEvaluation from './SpeechEvaluation.vue'
    import ChoiceCard from './ChoiceCard.vue'
    import Evaluate from './Evaluate.vue'
    import VoiceCard from './VoiceCard.vue'

    export default {
        components: {VoiceCard, Evaluate, SpeechEvaluation, ChoiceCard},
        name: 'StudentReport',
        data () {
            return {
                query: null,
                title: null,
                speechTotalNum: 0,
                speechWrongNum: 0,
                gameTotalNume: 0,
                gameWrongNum: 0,
                gameRightNum: 0,
                seriousness: 0,
                positive: 0,
                progress: 0,
                comprehensive: 0,
                teacherGamesUrl: '',
                teacherGamesVoiceTime: 0,
                teacherSpeechUrl: '',
                teacherSpeechVoiceTime: 0,
                teacherUrl: '',
                teacherVoiceTime: 0,
                ifShow: false,
                studentSpeechTopicDtoList: [],
                studentGamesRightDtoList: [],
                studentGamesWrongDtoList: [],
                studentGamesTopicDtoList: []
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => vm.getWechatConfig())
        },
        beforeRouteUpdate (to, from, next) {
            this.getWechatConfig()
            next()
        },
        created () {
            this.getData(this.$route.query)
            this.title = this.$route.query.title
        },
        methods: {
            getWechatConfig () {
                this.$axios({
                    method: 'get',
                    url: '/api/weixin/share',
                    params: {url: window.location.href.split('#')[0]}
                }, process.env.WECHAT_BASE).then((res) => {
                    let {data} = res
                    data.debug = false
                    data.jsApiList = [
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareQZone'
                    ]
                    window.wx.config(data)
                    window.wx.ready(() => console.log('wechat ready'))
                    window.wx.error(res => console.log(res))
                })
            },
            getData (query) {
                this.$axios({
                    method: 'get',
                    url: '/classrecord/api/v1/classes/student/report',
                    params: query
                }).then((res) => {
                    let {data} = res
                    let speechWrong = []
                    let gameWrong = []
                    let gameRight = []

                    data.studentSpeechTopicDtoList && data.studentSpeechTopicDtoList.map((v) => {
                        if (v.grade < 70) {
                            speechWrong.push(v.grade)
                        }
                    })
                    data.studentGamesTopicDtoList && data.studentGamesTopicDtoList.map((v) => {
                        if (v.correctAnswer === v.studentAnswer) {
                            gameRight.push(v)
                        } else {
                            gameWrong.push(v)
                        }
                    })
                    this.speechTotalNum = data.studentSpeechTopicDtoList.length
                    this.speechWrongNum = speechWrong.length
                    this.comprehensive = data.comprehensive
                    this.positive = data.positive
                    this.progress = data.progress
                    this.seriousness = data.seriousness
                    this.studentSpeechTopicDtoList = data.studentSpeechTopicDtoList
                    this.gameTotalNume = data.studentGamesTopicDtoList.length
                    this.studentGamesRightDtoList = gameRight
                    this.studentGamesWrongDtoList = gameWrong
                    this.gameWrongNum = gameWrong.length
                    this.gameRightNum = gameRight.length
                    this.teacherGamesUrl = data.teacherGamesUrl
                    this.teacherGamesVoiceTime = data.teacherGamesVoiceTime
                    this.teacherSpeechUrl = data.teacherSpeechUrl
                    this.teacherSpeechVoiceTime = data.teacherSpeechVoiceTime
                    this.teacherUrl = data.teacherUrl
                    this.teacherVoiceTime = data.teacherVoiceTime
                    this.ifShow = data.comprehensive || data.positive || data.progress || data.seriousness || data.teacherUrl
                    let shareOpt = {
                        title: '双师英语课堂' + this.title, // 分享标题
                        desc: '本节课您的孩子十分努力，快来看看孩子的学习报告吧！', // 分享描述
                        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: location.origin + '/apple-touch-icon.png', // 分享图标
                        success: function () {
                            console.log('success')// 用户确认分享后执行的回调函数
                        }
                    }
                    window.wx.onMenuShareTimeline(shareOpt)
                    window.wx.onMenuShareAppMessage(shareOpt)
                    window.wx.onMenuShareQQ(shareOpt)
                    window.wx.onMenuShareQZone(shareOpt)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .student-title {
        font-size: 18px;
        color: #333;
        height: 70px;
        line-height: 70px;
        text-align: center;
        background: #e5ebed;
    }

    .student-data {
        padding: 0 15px;
        .student-report {
            padding: 15px 0 10px 0;
            background: #fff;
            .head-general {
                background: #F6F9FD;
                border-radius: 5px;
                margin-bottom: 20px;
            }
            .voice-card {
                padding-bottom: 20px;
                font-size: 14px;
                p {
                    margin: 0;
                    color: #AAAAAA;
                    letter-spacing: 0;
                    line-height: 14px;
                    .total-color {
                        color: #333;
                    }
                    .wrong-color {
                        color: #ff6058;
                    }
                    .right-color {
                        color: #2CA6FC;
                    }
                }
                .card-whole {
                    display: flex;
                    display: -webkit-flex;
                    flex-wrap: wrap;
                    flex-direction: row;
                    justify-content: space-between;
                }
            }
            .line {
                height: 1px;
                width: 100%;
                margin: 20px 0;
                background: #EBEBEB;
            }
            .speech-whole {
                padding: 10px 0 20px 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/StudentReport.vue